<template>
  <IQOS :title="$t('subscription.title')" class="full-width" v-if="atLeastOneModeActive">
    <SubscriptionBadge
      class="badge-component"
      :subscription="subscriptions.inside"
      v-if="subscriptions.inside && (modes.inside || subscriptions.inside.liqpay_id || isInsideLiteEnabled) && hasFeatureMode('inside') && !isProActive && !isHotel"
    />
    <SubscriptionBadge
      class="badge-component"
      :subscription="subscriptions.inside_lite"
      v-if="canShowInsideLite && hasFeatureMode('inside') && !isProActive"
    />
    <SubscriptionBadge
      class="badge-component"
      :subscription="subscriptions.preorder"
      v-if="subscriptions.preorder && (modes.preorder || subscriptions.preorder.liqpay_id) && hasFeatureMode('preorder') && !isProActive"
    />
    <SubscriptionBadge
      class="badge-component"
      :subscription="subscriptions.delivery"
      v-if="subscriptions.delivery && (modes.delivery || subscriptions.delivery.liqpay_id) && hasFeatureMode('delivery') && !isProActive"
    />
    <SubscriptionBadge
      class="badge-component"
      :subscription="subscriptions.reserve"
      v-if="subscriptions.reserve && (modes.reserve || subscriptions.reserve.liqpay_id) && hasFeatureMode('reserve') && !isProActive"
    />
    <SubscriptionBadge
      class="badge-component"
      :subscription="subscriptions.hotels"
      v-if="subscriptions.hotels && (modes.hotels || subscriptions.hotels.liqpay_id) && !isProActive"
    />
    <SubscriptionBadge
      class="badge-component"
      :subscription="subscriptions.pro"
      v-if="canShowPro"
    />
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";

import ModeIcon from "@/components/ModeIcon.vue";
import SubscriptionBadge from "@/components/subscriptions/SubscriptionBadge.vue";

export default {
  components: {
    IQOS,
    ModeIcon,
    SubscriptionBadge,
  },
  methods: {
    hasFeatureMode(mode) {
      return this.$store.getters["worldwide/checkSystem"](mode);
    },
  },
  computed: {
    subscriptions() {
      return this.$store.getters["subscriptions/all"];
    },
    atLeastOneModeActive() {
      return (
        this.modes.inside || this.modes.delivery || this.modes.preorder || this.modes.reserve || this.modes.hotels || this.isInsideLiteEnabled
      )
    },
    canShowPro() {
      return this.subscriptions.pro && this.atLeastOneModeActive && !this.isHotel;
    },
    isProActive() {
      if (!this.subscriptions.pro) return false;

      return !!this.subscriptions.pro.liqpay_id;
    },
    cafe() {
      return this.$store.state.cafe;
    },
    isInsideLiteEnabled() {
      return !!this.cafe.inside_lite;
    },
    modes() {
      return this.cafe.modes;
    },
    isHotel() {
      return this.$store.getters.isHotel;
    },
    canShowInsideLite() {
      if (!this.subscriptions.inside_lite) return false;

      return [95, 71, 80, 104, 165, 90, 91, 162, 156].includes(this.cafe._id) || this.isInsideLiteEnabled;
    },
  },
};
</script>

<style scoped>
span.commission {
  background: #464646;
  padding: 0.4vh 2vh 0.4vh 3vh;
  display: inline-flex;
  z-index: 0;
  color: #ededed;
  width: 15vh;
  margin-left: -1vh;
  border-radius: 0 0.8vh 0.8vh 0;
  font-size: 1.7vh;
}

.commission.fix-price {
  padding: 0.4vh 0 0.4vh 1.8vh;
}

.inside {
  background: #262626 !important;
  color: #ededed;
}
.preorder {
  background: #ffd2a8 !important;
  color: #1d1d1b !important;
}
.delivery {
  background: #cbd9e6 !important;
  color: #1d1d1b !important;
}
.reserve {
  background: #aeccc6 !important;
  color: #1d1d1b !important;
}

.flag {
  display: flex;
  margin-top: 1.2vh;
  position: relative;
}

.flag:first-child {
  margin: 0;
}

.flag .mode {
  color: #ededed;
  text-align: center;
  position: relative;
  z-index: 2;
  font-weight: bold;
  width: 11vh;
  display: inline-block;
  border-radius: 0.8vh;
  font-size: 1.7vh;
  background: #262626;
  padding: 0.45vh 0 0;
}

.flag-disabled {
  color: #a4a3a1;
}

small.status-flag {
  color: #908f8d;
  font-size: 1.5vh;
}

small.status-flag.active {
  color: #129b81;
}

small.status-flag.end {
  color: #e2223b;
}

.badge-component {
  margin-bottom: 2.6vh;
}

.badge-component:last-child {
  margin-bottom: 0;
}

.full-width {
  width: 100%;
}
</style>